define(
  'app/views/location_city_select_zone',['app/setup'],
  function(takhfifan) {

    takhfifan.LocationCityZoneSelector = takhfifan.BaseView.extend({
      events: {
        "click #czSelectMap .city-map-area": "filterMapSelection",
        "submit #czSelectForm" : "filterFormSelection",
        "keyup #zoneNumber" : "validateZoneNumber",
        "click #showAllZone" : "showAllZones"
      },

      initialize: function() {
        $('body').addClass('all-location-page');
        this.$zoneList = this.$el.find('#czList');
      },

      filterMapSelection: function(e){
        var zoneId = $(e.currentTarget).data('id');
        this.filterZones(zoneId);
      },

      filterFormSelection: function(e){
        e.preventDefault();
        var zoneId = $(e.currentTarget).find('#zoneNumber').val();
        this.filterZones(zoneId);
        return false;
      },

      filterZones: function(zoneId){
        this.$zoneList.addClass('filtered');
        this.$zoneList.find('.city-zone-list.active').removeClass('active');
        this.$zoneList.find('.city-zone-list[data-zone=' + zoneId + ']').addClass('active');

        this.$el.find('#czSelectMap .city-map-area').attr("class", "city-map-area");
        this.$el.find('#czSelectMap .city-map-area[data-id=' + zoneId + ']').attr("class", "city-map-area active");

        $('html, body').animate({
          scrollTop: this.$zoneList.offset().top - 70
        }, 500);
      },

      validateZoneNumber: function(e){
        var currentVal = $(e.currentTarget).val();
        if(!$.isNumeric(currentVal) && currentVal!==''){
          $(e.currentTarget).val(this.prevVal);
        }
        this.prevVal = $(e.currentTarget).val();
      },

      showAllZones: function(){
        this.$zoneList.removeClass('filtered');
        this.$el.find('#czSelectMap .city-map-area').attr("class", "city-map-area");
        this.$zoneList.find('.city-zone-list.active').removeClass('active');
      }

    })
  });
